<ng-container>
    <div class="row search-part" [ngBusy]="{busy: busyGet, message: 'Veuillez patienter ...', backdrop: false}" >

        <div class="col-md-12 col-sm-12 mb-0" >

            <div class="row">
                <div class="col-md-12 col-sm-12 mb-0" style="position:relative">
                    <input style="display: inline-block;width: 90%;" class="form-control custom-input" placeholder="Recherche prestataire" autocomplete="off"
                    [(ngModel)]="searchKey" (keyup)="getItems()" name="searchKey" type="text" [disabled]="isDisabled">

                    <!-- <button type="button" class="btn btn-default btn-xs btn-close-item pull-right" title="Vider" (click)="reinitValue()"  [disabled]="isDisabled">
                        <i class="fa fa-times"></i> 
                    </button>  -->
                    <!-- <button [disabled]="!((itemSelected && itemSelected?.id) || searchKey)" type="button" class="btn btn-default btn-xs btn-close-item pull-right" title="Vider" (click)="reinitValue()"  [disabled]="isDisabled">
                        <i class="fa fa-times"></i> 
                    </button>  -->
                </div>
          
            </div>
           
            <div class="row search-adherent-part" *ngIf="canDisplay">
                <table class="table table-stripped table-bordered table-hover">
                    <thead>
                        <tr class="custom-table-head">
                            <th>#</th>
                            <th>Prestataire</th>
                            <th>Adresse
                                <button type="button"  class="btn btn-xs btn-close-search pull-right" title="Fermer" (click)="canDisplay = false;selectedItem()">
                                    <i class="fa fa-times"></i>
                                </button>
                            </th>
                          
                        </tr>
                    </thead>

                    <tbody>
                        
                            <tr *ngFor="let item of listItem; let indice = index" (click)="selectedItem(item)" style="cursor: pointer;">
                                <td>
                                    {{indice + 1}}
                                </td>
                                <td [innerHTML]="item.styled">
                                    <!-- {{item?.pharmacieMedicamentLibelle}} -->
                                </td>
                                <td>
                                    {{ (item?.adresse | moneyFormat) || 0}}
                                </td>
                            </tr>
                            <tr *ngIf="!listItem || listItem.length == 0">
                                <td colspan="5" style="text-align: center;">
                                    <span> Aucune donnée disponible</span>
                                </td>
                            </tr>
                    </tbody>
                   
                </table>
            </div>
        </div>

    </div>
</ng-container>
